import { makeAutoObservable } from 'mobx';

import { ApiRoutes } from '../../config/ApiRoutes';
import { RootStore } from '../index';

export class AnnualReportApiStore {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  addAnualReport = (data: any) => {
    const {
      Add: { Endpoint, Method },
    } = ApiRoutes.AnnualReport;
    return this.rootStore.apiStore.call<any>({
      data,
      method: Method,
      url: Endpoint,
    });
  };

  getInitialData = (params: any = {}) => {
    const {
      GetInitialData: { Endpoint, Method },
    } = ApiRoutes.AnnualReport;
    return this.rootStore.apiStore.call<any>({
      method: Method,
      params,
      url: Endpoint,
    });
  };
}
